import type { StartLetterPrintJobIntent } from "../actions/startLetterPrintJob"
import { hasSamePrintSelection } from "../_logic/printJobSelection"

export const buildStartLetterPrintJobIntent = ({
  organizationId,
  itemIds,
  activeJobId,
  activeJobItemIds,
  failed,
}: {
  organizationId: string
  itemIds: readonly string[]
  activeJobId: string | null
  activeJobItemIds: readonly string[]
  failed: boolean
}): StartLetterPrintJobIntent => {
  const activeJobMatchesSelection = Boolean(
    activeJobId && hasSamePrintSelection(activeJobItemIds, itemIds),
  )
  const label = activeJobMatchesSelection && failed ? "PDF erneut vorbereiten" : "Rendern starten"

  if (!organizationId) return { kind: "blocked", label, disabledReason: "Organisation fehlt." }

  if (!itemIds.length)
    return { kind: "blocked", label, disabledReason: "Keine Terminbriefe ausgewählt." }

  if (activeJobMatchesSelection && !failed) {
    return { kind: "blocked", label, disabledReason: "Der Druckauftrag wurde bereits gestartet." }
  }

  return { kind: "start", label, organizationId, itemIds: [...itemIds] }
}
